<template>
  <div class="tickets-tab">
    <h2>Support Tickets</h2>
    <div class="btn-container ">
      <v-button
        :disabled="disabledBtn"
        @click="handlerClearSelection">Clear Selection</v-button>
      <v-button
        type="danger"
        :disabled="disabledBtn"
        @click="handlerSelected('unsnooze')">Unsnooze Now</v-button>
      <v-button
        type="success"
        :disabled="disabledBtn"
        @click="handlerSelected('resolved')">Mark As Resolved</v-button>
    </div>
    <div class="transparent">
      <el-table
        ref="table"
        :data="tableData"
        stripe
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="id"
          label="ID"></el-table-column>
        <el-table-column
          prop="subject"
          label="Subject"></el-table-column>
        <el-table-column
          prop="assignee"
          label="Assigned To"></el-table-column>
        <el-table-column
          prop="created_at"
          label="Created On"></el-table-column>
        <el-table-column
          prop="status_language"
          label="Status"></el-table-column>
        <el-table-column
          label="Type">
          <template slot-scope="scope">
            <span class="span-checkbox">{{ scope.row.type_language }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </div>
</template>
<script>
import { setResolvedTicket, setTicketUnsnooze } from '@/api/ticket'
export default {
  name: 'TicketsTab',
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      }, 
      selectionTickets: []
    }
  },
  computed: {
    tableData() {
      if(!this.form || !this.form.ticket || !this.form.ticket.data) {
        return []
      }
      return this.form.ticket.data
    },
    disabledBtn() {
      return this.selectionTickets.length < 1
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(formData) {
        if(formData.ticket) {
          this.pageConfig.total = formData.ticket.total
          if(this.pageConfig.currentPage != formData.ticket.current_page) {
            this.pageConfig.currentPage = formData.ticket.current_page
          }
        }
        
      }
    }
  },
  methods: {
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.handler().getData()
    },
    handleSelectionChange(val) {
      this.selectionTickets = val
    },
    handlerClearSelection() {
      this.$refs.table.clearSelection()
    },
    handlerSelected(type) {
      if(this.selectionTickets.length < 1) {
        return
      }
      const ticketId = this.selectionTickets.reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      if(type === 'resolved') {
        this.network().setResolvedTicket(ticketId)
      } else {
        this.network().setTicketUnsnooze(ticketId)
      }
    },
    handler() {
      return {
        getData: () => {
          this.$emit('update-data', {
            page: this.pageConfig.currentPage,
            ticket_size: '',
            ticket_type: '', // what？ todo
          })
        }
      }
    },
    network() {
      return {
        setResolvedTicket: async (ticketId) => {
          const { data } = await setResolvedTicket({
            ticket_id: ticketId
          })
          this.handler().getData()
        },
        setTicketUnsnooze: async (ticketId) => {
          const { data } = await setTicketUnsnooze({
            ticket_id: ticketId
          })
          this.handler().getData()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.tickets-tab {
    position: relative;
    .btn-container {
        margin-bottom: 10px;
        text-align: right;
    }
}
</style>